import React, {useEffect, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {LogoGroup} from "../icons/LogoGroup";
import {UserProfileIcon} from "../icons/UserProfileIcon";
import {useDispatch, useSelector} from "react-redux";
import {getUserProfile} from "../../slices/userProfileSlice";
import Select from "react-select";
import {languageStylesMainPage, languageStylesMainPageMobile} from "../../selectStyles";
import {CustomNoOptionsMessage} from "../hungryscan/cms/form-components/CustomNoOptionsMessage";
import {CustomSingleValueIcon} from "../hungryscan/cms/form-components/CustomSingleValueIcon";
import {supportedLanguages} from "../../i18n";
import {setChosenLanguage} from "../../slices/globalParamsSlice";
import {useWindowWidth} from "../../hooks/useWindowWidth";
import {CustomCollapsedOption} from "../hungryscan/cms/form-components/CustomCollapsedOption";
import {useLanguageRefresh} from "../../hooks/useLanguageRefresh";

export const NavMenu = () => {
    const {t, i18n} = useTranslation();
    const dispatch = useDispatch();
    const {userData} = useSelector(state => state.userProfile.getUserProfile);
    const {chosenLanguage} = useSelector(state => state.globalParams.globalParams);
    const languages = useMemo(
        () => Object.keys(supportedLanguages)
            .map(value => ({value, label: t(value), collapsedLabel: t(`${value}Short`)})),
        [t]
    );
    const windowWidth = useWindowWidth();
    const isMobile = windowWidth < 500;
    const isBeta = String(process.env.REACT_APP_IS_BETA) === 'true';

    const handleLanguageChange = selected => {
        const lang = selected.value;
        dispatch(setChosenLanguage({
            value: lang,
            label: t(lang),
            collapsedLabel: t(`${lang}Short`)
        }));
        i18n.changeLanguage(lang);
    }

    useEffect(() => {
        dispatch(getUserProfile());
    }, [dispatch]);

    useLanguageRefresh();

    const renderMenuButtons = () => {
        if (isBeta) return;
        return (
            <div className={'main-page-menu-buttons'}>
                <button className={'main-page-menu-button'} onClick={() => window.location.href = '/'}>
                    Home
                </button>
                <button className={'main-page-menu-button'} onClick={() => window.location.href = '/our-offer'}>
                    {t('ourOffer')}
                </button>
                <button className={'main-page-menu-button'} onClick={() => window.location.href = '/price-plans'}>
                    {t('pricePlans')}
                </button>
                <button className={'main-page-menu-button'} onClick={() => window.location.href = '/about-us'}>
                    {t('aboutUs')}
                </button>
                <button className={'main-page-menu-button'} onClick={() => window.location.href = '/contact'}>
                    {t('contact')}
                </button>
            </div>
        );
    }

    return (
        <div className={'main-page-menu'}>
            <div className={'main-page-menu-wrapper'}>
                <LogoGroup onClick={() => window.location.href = '/'}/>
                {renderMenuButtons()}
                <div className={'flex-centered'} style={{gap: '10px'}}>
                    <Select id={'language'}
                            name={'language'}
                            styles={isMobile ? languageStylesMainPageMobile : languageStylesMainPage}
                            value={chosenLanguage}
                            onChange={(selected) => handleLanguageChange(selected)}
                            placeholder={t('chooseLanguage')}
                            isClearable={false}
                            options={languages}
                            noHoverStyle={true}
                            isCollapsed={isMobile}
                            components={{
                                NoOptionsMessage: CustomNoOptionsMessage,
                                SingleValue: CustomSingleValueIcon,
                                CustomSingleValueIcon: CustomSingleValueIcon,
                                Option: CustomCollapsedOption
                            }}
                            closeMenuOnSelect={true}
                            menuPlacement={'top'}
                            isSearchable={false}
                            blurInputOnSelect={false}
                    />
                    <div className={'main-page-login-button-group'} onClick={() => window.location.href = '/sign-in'}>
                        <UserProfileIcon/>
                        {!isMobile && (
                            <button className={'main-page-login-button'}>
                                {userData?.forename ? `${t('welcome')} ${userData?.forename}!` : t('logInButton')}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}